import MUISkeleton from '@mui/material/Skeleton'

interface ISkeletonProps {
  variant: 'rectangular' | 'circular'
  height?: number
  width?: number
  margin?: number
  borderRadius?: number
}

export default function Skeleton({ variant, height, width, margin = 2, borderRadius = 4 }: ISkeletonProps) {
  return (
    <MUISkeleton
      variant={variant}
      height={height}
      width={width}
      sx={{
        borderRadius,
        margin,
      }}
    />
  )
}
